import { Dispatch, useMemo } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Action } from 'redux';

import { RootState } from '../../../lib/store';
import { FundamentalCall } from '../../../lib/store/fundamental/types';
import { hasValidCookie } from '../../../lib/store/selectors';
import { isCallStatusReady } from '../../../lib/util/error-handling/StatusByCallHelpers';

import { usePriceAndChartLoading } from '../../../hooks';
import { useSubscriptionManager } from '../../../hooks/useSubscriptionManager';
import { WatchListSortingType } from '../WatchList.types';

import WatchListTable from './WatchListTable';

type OwnProps = {
  sortingType: null | WatchListSortingType
}
type Props = ReduxProps & OwnProps;

const PopularWatchList = (props: Props) => {
  const {
    popularStocks,
    hasCookieSession,
    sortingType,
    companyLogoAndName,
    isPopularStocksCallComplete,
  } = props;

  const filteredStocks = popularStocks.map(({ popularity, symbolUniverseSymbol, ...rest }) => rest);

  const subscriptionSymbols = useMemo(
    () => filteredStocks.map(stock => ({
      symbol: stock.symbol,
      stockExchangeCode: stock.stockExchangeCode,
      countryDesignation: companyLogoAndName[stock.symbol]?.countryDesignation,
    })),
    [filteredStocks, companyLogoAndName],
  );

  useSubscriptionManager({
    symbols: subscriptionSymbols,
    enabled: filteredStocks.length > 0 && hasCookieSession,
    subscriptionLabel: 'Popular',
  });

  const isLoading = usePriceAndChartLoading({
    stocks: filteredStocks,
    isApiPending: !isPopularStocksCallComplete,
  });

  return (
    <WatchListTable
      sortingType={sortingType}
      isLoading={isLoading}
      watchListStocks={filteredStocks}
      title="popular"
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  isPopularStocksCallComplete: isCallStatusReady(FundamentalCall.getPopularStocks, state.fundamental.statusByCall),
  popularStocks: state.fundamental.popularStocks,
  hasCookieSession: hasValidCookie(state),
  companyLogoAndName: state.fundamental.companyLogoAndName,
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({});

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(PopularWatchList);
